import { useEffect, useState } from 'react';
import { RUNTIME_BACKEND_URL } from './backendUrl';

export const WEDDING_TEMPLATES = [
  { key: 'galeri', label: 'Galeri linki hazır', vars: ['gelin', 'damat', 'link', 'firma'],
    text: 'Merhaba {gelin} & {damat}! Düğün fotoğraflarınız hazır. Beğendiğiniz fotoğrafları seçmek için linke tıklayın: {link}' },
  { key: 'hatirlatma', label: 'Çekim hatırlatma', vars: ['gelin', 'damat', 'tarih', 'saat', 'mekan', 'firma'],
    text: 'Merhaba {gelin} & {damat}, {tarih} {saat} tarihli çekiminizi hatırlatmak isteriz. Mekan: {mekan}. Görüşmek üzere! — {firma}' },
  { key: 'odeme', label: 'Ödeme hatırlatma', vars: ['gelin', 'damat', 'kalan_odeme', 'firma'],
    text: 'Merhaba {gelin} & {damat}, kalan ödemeniz {kalan_odeme} TL\'dir. Bilginize sunarız. — {firma}' },
  { key: 'album_hazir', label: 'Albüm teslime hazır', vars: ['gelin', 'damat', 'firma'],
    text: 'Merhaba {gelin} & {damat}, albümünüz teslime hazır! Uygun olduğunuz bir zaman stüdyomuza bekleriz. — {firma}' },
  { key: 'tesekkur', label: 'Teşekkür', vars: ['gelin', 'damat', 'firma'],
    text: 'Sevgili {gelin} & {damat}, bizi tercih ettiğiniz için teşekkür ederiz. Mutluluklar dileriz! — {firma}' },
];

export const HESAP_TEMPLATES = [
  { key: 'borc', label: 'Veresiye borç hatırlatma', vars: ['musteri', 'borc', 'firma'],
    text: 'Sayın {musteri}, {firma} olarak hatırlatmak isteriz: güncel borç bakiyeniz {borc}\'dir. Ödemenizi en kısa sürede yapmanızı rica eder, iyi günler dileriz.' },
  { key: 'teklif', label: 'Teklif gönderme', vars: ['musteri', 'teklif_no', 'tarih', 'toplam', 'link', 'firma'],
    text: 'Sayın {musteri}, {teklif_no} numaralı teklifimiz hazırlanmıştır.\nTarih: {tarih}\nToplam: {toplam}\n{link}\nSorularınız için bize yazabilirsiniz. — {firma}' },
  { key: 'servis_hazir', label: 'Teknik servis: cihazınız hazır', vars: ['musteri', 'servis_no', 'cihaz', 'ucret', 'firma'],
    text: 'Sayın {musteri}, #{servis_no} numaralı servis kaydınızdaki {cihaz} cihazınızın onarımı tamamlandı ve teslime hazırdır. {ucret} Mesai saatlerimizde teslim alabilirsiniz. — {firma}' },
  { key: 'servis_durum', label: 'Teknik servis: durum bilgisi', vars: ['musteri', 'servis_no', 'cihaz', 'durum', 'firma'],
    text: 'Sayın {musteri}, #{servis_no} numaralı servis kaydınızdaki {cihaz} cihazınızın güncel durumu: {durum}. Gelişmelerden sizi haberdar edeceğiz. — {firma}' },
];

export const fillTemplate = (text, vars) => String(text || '')
  .replace(/\{(\w+)\}/g, (m, k) => (vars[k] !== undefined && vars[k] !== null ? String(vars[k]) : ''))
  .replace(/[ \t]+\n/g, '\n').replace(/\n{3,}/g, '\n\n').trim();

const cache = {};

// Kullanıcının kendi şablonları (yoksa varsayılan) — path: '/api' veya '/api/hesap'
export const useMessageTemplates = (path, token, defaults) => {
  const [custom, setCustom] = useState(cache[path] || {});
  useEffect(() => {
    if (!token || cache[path]) return;
    fetch(`${RUNTIME_BACKEND_URL}${path}/message-templates`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => (r.ok ? r.json() : {})).then(d => { cache[path] = d; setCustom(d); }).catch(() => {});
  }, [path, token]);
  const get = (key) => custom[key] || defaults.find(t => t.key === key)?.text || '';
  return { get, custom, setCustom: (d) => { cache[path] = d; setCustom(d); } };
};
